module.exports = __webpack_public_path__ + "static/media/site-setting.367a31df.svg";